export default __webpack_public_path__ + "static/media/fb.925c8064.svg";